<template>
    <div @click="close" aria-hidden="true" class="modal-sms popup popup_show">
        <div class="popup__wrapper">
            <div class="popup__content">
                <button @click="close" type="button" class="popup__close">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#close"></use>
                    </svg>
                </button>
                <div class="popup__col popup__col_right" :class="{'disabled-buttons':loading}">
                    <phone-modal-request v-show="!smsSent"
                        :time="time"
                        :phoneError="phoneError"
                        @input="resetPhoneError"
                        @send="sendSms"/>
                    <phone-modal-confirm v-show="smsSent"
                        :time="time"
                        :phone="phone"
                        @send="sendSms"
                        @change="change"
                        @set="set"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PhoneModalRequest from "./PhoneModalRequest";
import PhoneModalConfirm from "./PhoneModalConfirm";
import axios from "axios";

export default {
    components: {
        "phone-modal-request": PhoneModalRequest,
        "phone-modal-confirm": PhoneModalConfirm
    },
    data() {
        return {
            phone: null,
            smsSent: false,
            time: 0,
            timer: null,
            phoneError: {
                status: false,
                message: false
            },
            loading: false
        }
    },
    mounted() {
    },
    computed: {
        count() {
            if (this.isset(this.$store.state.cart.data)) {
                return this.$store.state.cart.data.length;
            } else {
                return 0;
            }
        }
    },
    methods: {
        resetPhoneError() {
            this.phoneError = {
                status: false,
                message: false
            };
        },
        timerSet() {
            this.time = 60;
            clearInterval(this.timer);
            this.timer = setInterval(() => { 
                if (this.time > 0) {
                    this.time -= 1;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        sendSms(data = this.phone) {
            // No more sms than once per minute
            if (this.time > 1) return false;
            this.loading = true;
            // Set phone
            this.phone = data;
            // Make request
            axios({
                method: "post",
                url: window.globalVariables.locale + "/login/by_sms/send",
                data: {
                    phone: this.phone,
                }
            })
            .then(response => {
                switch (response.data.status) {
                    case "success":
                        this.smsSent = true;
                        this.timerSet();
                        this.phoneError = {
                            status: 'success',
                            message: this.trans('auth.code_sent')
                        };
                        break;
                    case "failed":
                        this.phoneError = {
                            status: 'error',
                            message: this.trans('auth.error_try_other_method')
                        };
                        break;
                    case "wait":
                        this.phoneError = {
                            status: 'warning',
                            message: this.trans('auth.wait_one_minute')
                        };
                        break;
                    case "not_exists":
                        this.phoneError = {
                            status: 'warning',
                            message: this.trans('auth.user_not_registered')
                        };
                        break;
                    default:
                        this.phoneError = {
                            status: 'error'
                        };
                        break;
                }
                this.loading = false;
            })
            .catch(error => {
                this.phoneError = {
                    status: 'error',
                    message: trans('auth.error_try_other_method')
                };
                this.loading = false;
                console.log(error);
            });
        },
        set(data) { 
            this.$emit("set", data);
        },
        change() {
            this.smsSent = false;
        },
        close(event) {
            if (
                !event.target.closest(".popup__content") ||
                event.target.closest(".popup__close")
            ) {
                this.$emit("close");
            }
        }
    }
}
</script>